/* eslint-disable import/prefer-default-export */
import http from './http';
import config from './config';

export const chartData = async () => {
  const urlElements = window.location.href.split('/');
  const params = Object.fromEntries(new URLSearchParams(window.location.search));
  let lang = 'en';
  if (params.lang !== undefined && ['en', 'es'].includes(params.lang) >= 0) {
    lang = params.lang;
  }
  let projectString = urlElements[4];
  if (projectString.indexOf('?') >= 1 && (urlElements[3] === 'egm' || urlElements[3] === 'egm-draft' || urlElements[3] === 'egm-embedded')) {
    const projectStringArray = projectString.split('?');
    [projectString] = projectStringArray;
  }
  return http.post(`${config.url}get_map_data`, { project_id: Number(localStorage.getItem(`${projectString}_project_id`)), lang })
    .then((response) => response)
    .catch(() => '');
};
